import { c as r } from "../../../../index.esm-BeDSGXP5.js";
import { css as e } from "styled-components";
const s = {
  base: ({ theme: o }) => /* @__PURE__ */ e([
    "display:inline-flex;justify-content:center;align-items:center;border-radius:50%;",
    ""
  ], r({
    height: [
      "3.2rem",
      null,
      "4.8rem"
    ],
    width: [
      "3.2rem",
      null,
      "4.8rem"
    ],
    backgroundColor: o.componentColors.badge.backgroundColor,
    color: o.componentColors.badge.color
  }))
};
export {
  s as default
};
